
    <div class="ui-g-12 no-padding">
      <div id="autocomplete-container" class="autocomplete-container"></div>
    </div>
  